<template>
	<div class="info-drawer">
		<el-drawer :visible.sync="drawer" :title="title" size="761px" :before-close="handleClose" :destroy-on-close="true">
			<div class="drawer-wrap">
				<div class="content">
					<el-table
						@sort-change="sortChange"
						v-loading="loading"
						element-loading-text="加载中"
						element-loading-background="rgba(255, 255, 255)"
						:data="list"
						header-row-class-name="table-header-row"
						row-class-name="table-row"
					>
						<el-table-column label="商品信息" min-width="150" v-if="type == 1">
							<template v-slot="{ row }">
								<div class="flex flex-align-center fz-14">
									<div class="left">
										<el-avatar :size="48" shape="square" :src="row.product_img" @error="errorHandler">
											<img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" />
										</el-avatar>
									</div>
									<div class="right ml-12">
										<div class="top flex flex-align-center pointer">
											<platform-icon :platformId="row.platform_id"></platform-icon>
											<span class="ml-4 title hover" @click="handLink(row.product_url)">{{ row.product_name }}</span>
										</div>
										<div class="bottom mt-6">
											<span class="yx-color-text-secondary">商品ID：</span>
											<span>{{ row.third_product_id }}</span>
										</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="达人信息" min-width="150" v-if="type == 2">
							<template v-slot="{ row }">
								<div class="flex flex-align-center fz-14">
									<div class="left">
										<el-avatar :size="48" :src="row.head || defaultAvatar"></el-avatar>
									</div>
									<div class="right ml-12">
										<div class="top flex flex-align-center">
											<platform-icon :platformId="row.platform_id"></platform-icon>
											<p class="ml-4 title">{{ row.author_account }}</p>
										</div>
										<div class="bottom mt-6">
											<span class="yx-color-text-secondary">{{ row.platform_id | formatPlatformName('unify') }}：</span>
											<span>{{ row.author_short_id }}</span>
										</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="团长信息" min-width="150" v-if="type == 3">
							<template v-slot="{ row }">
								<div class="top flex flex-align-center pointer hover">
									<platform-icon :platformId="row.platform_id"></platform-icon>
									<p class="ml-4 title">{{ row.sec_institution_name }}</p>
								</div>
							</template>
						</el-table-column>

						<el-table-column label="支付订单量" sortable="custom" prop="order_num" width="150">
							<template v-slot="{ row }">
								<p>{{ row.order_num || '0' }}</p>
							</template>
						</el-table-column>
						<el-table-column label="支付订单金额" sortable="custom" prop="money" width="150">
							<template v-slot="{ row }">
								<p>
									<span class="fz-12 DIN">¥</span>
									{{ row.money || '--' }}
								</p>
							</template>
						</el-table-column>
						<empty ref="empty" slot="empty"></empty>
					</el-table>
					<yx-pagination
						:total="total"
						:current-page="params.page"
						:page-size="params.page_size"
						@size-change="sizeChange"
						@current-change="currentChange"
					></yx-pagination>
				</div>
				<div class="bottom-btn">
					<el-button type="primary" @click="handleClose">我知道了</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import { rankingSecondaryProducts, rankingProductAnchors, rankingProductSecondarys, rankingAnchorProducts } from '@/api/ranking';
import empty from '@/views/common/empty/index.vue';
import mixin from '@/mixins';
export default {
	name: 'infoDrawer',
	mixins: [mixin],
	components: {
		empty,
	},
	data() {
		return {
			drawer: false,
			list: [],
			total: '0',
			loading: false,
			circleUrl: 'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png',
			title: '',
			type: 0,
			params: {
				page: 1,
				page_size: 10,
			},
			obj: {},
		};
	},
	computed: {},
	methods: {
		show(type, title, obj, status) {
			this.status = status;
			this.obj = obj;
			this.type = type;
			this.title = title;
			this.getList();
			this.drawer = true;
		},
		async getList() {
			if (this.type == 1) {
				if (this.status) {
					const {
						code,
						data: { list, total },
					} = await rankingSecondaryProducts({ ...this.obj, ...this.params });
					if (code !== 0) return;
					this.total = total;
					this.list = list;
				} else {
					const {
						code,
						data: { list, total },
					} = await rankingAnchorProducts({ ...this.obj, ...this.params });
					if (code !== 0) return;
					this.total = total;
					this.list = list;
				}
			} else if (this.type == 2) {
				const {
					code,
					data: { list, total },
				} = await rankingProductAnchors({ ...this.obj, ...this.params });
				if (code !== 0) return;
				this.total = total;
				this.list = list;
			} else if (this.type == 3) {
				const {
					code,
					data: { list, total },
				} = await rankingProductSecondarys({ ...this.obj, ...this.params });
				if (code !== 0) return;
				this.total = total;
				this.list = list;
			}
		},
		handleClose() {
			this.params = {
				page: 1,
				page_size: 10,
			};
			this.drawer = false;
		},
		sizeChange(size) {
			this.params.page_size = size;
			this.getList();
		},
		currentChange(index) {
			this.params.page = index;
			this.getList();
		},
		errorHandler() {
			return true;
		},
		handLink(link) {
			var a = document.createElement('a');
			a.setAttribute('href', link);
			a.setAttribute('target', '_blank');
			a.setAttribute('id', 'startTelMedicine');
			// 防止反复添加
			if (document.getElementById('startTelMedicine')) {
				document.body.removeChild(document.getElementById('startTelMedicine'));
			}
			document.body.appendChild(a);
			a.click();
		},
		sortChange({ prop, order }) {
			this.params.order = prop || '';
			this.params.sort = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : '';
			this.getList();
		},
	},
};
</script>

<style lang="less" scoped>
.info-drawer {
	.drawer-wrap {
		background: #fff;
		height: 100%;
		overflow: hidden;
		padding-bottom: 61px;
		.content {
			height: 100%;
			position: relative;
			overflow-y: auto;
			padding: 24px;
			box-sizing: border-box;
		}
		.title {
			max-width: 260px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
	.bottom-btn {
		border-top: 1px solid #eee;
		text-align: right;
		padding: 14px 24px;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
	}
	/deep/ .el-avatar {
		background: #fff;
	}
}
</style>
